import styled, { css } from 'styled-components'

export const TopBottomKeysWrapper = styled.div`
  ${({ theme }) => theme.typography.body2};
  color: white;
  & > div:nth-child(1),
  & > div:nth-child(4) {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`

const flexAJCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Row = styled.div`
  ${flexAJCenter};
  flex-grow: 1;
`

export const ActionCard = styled.div<{ success?: boolean }>`
  height: 6.875rem;
  width: 7.25rem;
  border-radius: 4px;
  display: flex;
  margin-right: auto;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(1.5, 1)};
  margin-right: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ success }) => (success ? '#25A95F' : '#EF9F08')};

  ${({ theme }) => theme.typography.smallText2};

  & > div:nth-child(2) {
    ${({ theme }) => theme.typography.body2};
  }

  &:hover > div:nth-child(3) {
    text-decoration: underline;
    cursor: pointer;
  }
`

interface StateCardProps {
  bg: string
}

export const StatCard = styled.div<StateCardProps>`
  background-color: ${({ bg }) => bg && bg};
  height: 6.875rem;
  width: 5.2rem;
  overflow: hidden;
  border-radius: 4px;

  & > div:nth-child(1) {
    height: 81px;
    font-size: 2.4rem;
    ${flexAJCenter}
  }

  & > div:nth-child(2) {
    ${flexAJCenter};
    height: 29px;
    background-color: rgba(255, 255, 255, 0.25);
  }

  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`
